import { HttpContextToken } from '@angular/common/http';

export const SKIP_ERROR_REPORT = new HttpContextToken<boolean>(() => false);
export const SUPPRESS_5XX_NOTIFICATION = new HttpContextToken<boolean>(() => false);
